import styled from 'styled-components';
import { Button } from 'antd';

export const ButtonCancell = styled(Button).attrs({
    children: 'Cancelar',
})``;

export const ButtonConfirm = styled(Button).attrs({
    type: 'primary',
})``;
